import React from "react";
import "./Spinner.css";

const Spinner = () => {
  return (
    <div className="spinner-position">
      <div class="loadingio-spinner-double-ring-j781j5yv7ur">
        <div class="ldio-agl8sjrmhgv">
          <div></div>
          <div></div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
